module.exports = __webpack_public_path__ + "img/tenant-logo.597da55d.svg";